import {
    React,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
    Paper,
    styled
} from '../../utils/globalImports';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: '#1e66ab',
        fontSize: 18,
        fontWeight: '600',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        color: '#1e66ab',
    },
}));

type DynamicTableProps<T extends object> = {
    data: any;
    columnsConfig?: Partial<Record<keyof T, string>>;
    scrollX?: boolean;
};

export default function CustomTableView<T extends object>({
    data,
    columnsConfig,
    scrollX = false,
}: DynamicTableProps<T>) {
    const columns = React.useMemo(() => {
        if (data.length === 0) return [];
        return Object.keys(data[0]) as (keyof T)[];
    }, [data]);

    const capitalize = (text: string) =>
        text.charAt(0).toUpperCase() + text.slice(1);

    const renderHeader = (col: keyof T) => {
        if (columnsConfig && columnsConfig[col]) return columnsConfig[col];
        return capitalize(col as string);
    };

    return (
        <TableContainer component={Paper}
            sx={{
                border: '1px solid rgba(224, 224, 224, 1)',
                maxHeight: 500,              // Set your fixed height
                overflowY: 'auto'            // Enable vertical scrolling
            }}
        >
            <Table
                stickyHeader
                sx={{ minWidth: 700, tableLayout: 'fixed' }}>
                <TableHead>
                    <TableRow>
                        {columns.map((col) => (
                            <StyledTableCell key={col as string}>
                                {renderHeader(col)}
                            </StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {columns.map((col) => (
                                <StyledTableCell key={col as string}>
                                    {String(row[col])}
                                </StyledTableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
